<div
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  (focus)="showIcon = true"
  (mouseleave)="showIcon = false"
  (mouseover)="showIcon = true"
  tabindex="0"
  [ngClass]="{
    'p-3': isExpanded,
    'p-2': !isExpanded,
  }"
  aria-label="Dropdown menu content"
  class="elevation dropdown-menu flex h-14 w-full items-center justify-between rounded font-medium">
  <div *ngIf="selectedItem" class="flex items-center text-md font-normal">
    <app-avatar
      [backgroundColor]="(avatarColors$ | async)?.backgroundColor"
      [color]="(avatarColors$ | async)?.color"
      [label]="selectedItem.label"
      aria-label="Dropdown avatar"></app-avatar>
    <span
      *ngIf="isExpanded"
      aria-label="Dropdown menu label"
      class="mx-3 block max-w-52 overflow-hidden text-ellipsis">
      {{ selectedItem.label }}
    </span>
  </div>
  <mat-icon *ngIf="isExpanded && showIcon" aria-label="Arrow down icon">arrow_drop_down</mat-icon>
</div>

<mat-menu #menu="matMenu" aria-label="Dropdown menu items" (closed)="onMenuClosed()">
  <!-- Search Input -->
  <div
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
    tabindex="0"
    class="quick-search mx-3 mb-2 h-10 items-center rounded-lg">
    <input
      class="h-8 w-full"
      matInput
      [formControl]="searchControl"
      [placeholder]="'global.quickSearch' | translate"
      aria-label="Search menu items" />
    <mat-icon class="mr-2" aria-label="Search icon" matPrefix>search</mat-icon>
  </div>

  <!-- Filtered Items -->
  <div class="max-h-80 w-[355px] overflow-y-auto">
    <div #itemElements *ngFor="let item of filteredItems">
      <button
        (click)="change(item)"
        [ngClass]="{
          'active-item': selectedItem === item,
        }"
        aria-label="Change dropdown menu item"
        class="hover:active-item h-16"
        mat-menu-item>
        <div class="flex w-full justify-between">
          <div class="flex basis-2/3">
            <app-avatar
              [backgroundColor]="(avatarColors$ | async)?.backgroundColor"
              [color]="(avatarColors$ | async)?.color"
              [label]="item.label"
              aria-label="Dropdown menu item avatar"></app-avatar>
            <div class="ml-4 flex flex-col justify-center font-medium">
              <div
                aria-label="Dropdown menu item label"
                class="block max-w-52 overflow-hidden text-ellipsis">
                {{ item.label }}
              </div>
              <div
                aria-label="Dropdown menu item sublabel"
                class="block max-w-52 overflow-hidden text-ellipsis text-xs">
                {{ item.subLabel }}
              </div>
            </div>
          </div>
          <mat-radio-group aria-label="Menu item selection" [formControl]="menuItemControl">
            <mat-radio-button class="basis-1/4 text-end" [value]="item.id"></mat-radio-button>
          </mat-radio-group>
        </div>
      </button>
    </div>
  </div>
  <ng-content select="appendix"></ng-content>
</mat-menu>
